// Physical settings of the property — the storytelling grouping for rooms.
// Used by Home (story scenes) and TheStay (grouping + filters).
export const SETTINGS = [
  {
    id: 'water',
    name: 'By the Water',
    tagline: 'Beside the water — the natural pond and waterfall, and the swimming pool.',
  },
  {
    id: 'caves',
    name: 'Into the Stone',
    tagline: 'Stays set against cave rock — naturally cool, quiet, unlike anywhere else.',
  },
  {
    id: 'heart',
    name: 'The Heart of the Resort',
    tagline: 'Around the stage, bar and courtyards, where the evenings happen.',
  },
  {
    id: 'garden',
    name: 'Among the Green',
    tagline: 'Beside the greenhouse and gardens — the desert’s soft corner.',
  },
];

// ponytail: hardcoded slug → setting map; move to a room field in the DB if rooms change often
export const ROOM_SETTING = {
  'cascade-cottages': 'water',
  'grand-quad': 'water',
  'heritage-huts': 'caves',
  'catacomb-suite': 'caves',
  'golden-adobe': 'heart',
  'desert-riad-suite': 'heart',
  'cocoon': 'garden',
  'blue-enclave': 'garden',
};

export const settingOf = (room) => ROOM_SETTING[room.slug] || 'heart';
export const settingNameOf = (room) =>
  SETTINGS.find((s) => s.id === settingOf(room))?.name;
// Signature status follows the rack rate (original_price when discounted), so a
// seasonal discount doesn't demote rooms out of the homepage Signature section.
// Math.max guards against a mistyped original_price below the real price.
export const isSignature = (room) =>
  Math.max(room.original_price || 0, room.price_per_night) >= 10000;

// Shown next to discounted prices; edit here for the next occasion (Christmas, NY…).
export const OFFER_NOTE = 'Festive Season Offer — ends 27 October';
export const EXTRA_BED_NOTE = 'Extra bed ₹799/night — on request, payable at resort';
